<script setup>
/** 耗时最长的几段：图上的色块和空档按时长排，时间主要花在哪一眼看到。 */
import { computed } from 'vue'
import { Badge } from '@drama/ui'
import { useI18n } from 'vue-i18n'
import { formatSeconds, longestSpans } from './timeline-layout.js'

const props = defineProps({
  timeline: { type: Object, required: true },
})

const { t, te } = useI18n()

/** 和时间轴主图同一套标签：角色、节点名是开放集合，没有翻译就显示原名。 */
function label(key, params, fallback) {
  const path = `visualGameAdmin.llm.turnTimelines.chart.${key}`
  return te(path) ? t(path, params) : fallback
}

function laneVariant(lane) {
  switch (lane) {
    case 'idle':
      return 'danger'
    case 'model':
      return 'info'
    case 'tts':
      return 'warning'
    case 'events':
      return 'neutral'
    default:
      return 'success'
  }
}

function laneText(lane) {
  return lane === 'idle' ? t('visualGameAdmin.llm.turnTimelines.spans.idle') : t(`visualGameAdmin.llm.turnTimelines.chart.lanes.${lane}`)
}

const spans = computed(() => longestSpans(props.timeline, label, 6))
const total = computed(() => props.timeline.nodes.length === 0 ? 1 : props.timeline.nodes[props.timeline.nodes.length - 1].at_ms)
</script>

<template>
  <ol class="timeline-spans">
    <li v-for="(span, index) in spans" :key="index">
      <div class="timeline-spans__head">
        <strong>{{ formatSeconds(span.end_ms - span.start_ms) }}</strong>
        <span>{{ t('visualGameAdmin.llm.turnTimelines.spans.share', { percent: Math.round((span.end_ms - span.start_ms) / total * 100) }) }}</span>
      </div>
      <div class="timeline-spans__meter"><i :style="{ width: `${(span.end_ms - span.start_ms) / (spans[0].end_ms - spans[0].start_ms) * 100}%` }" /></div>
      <div class="timeline-spans__what">
        <Badge :variant="laneVariant(span.lane)">{{ laneText(span.lane) }}</Badge>
        <span>{{ span.name }}</span>
        <span v-if="span.detail !== null" class="timeline-spans__detail">{{ span.detail }}</span>
      </div>
    </li>
  </ol>
</template>

<style scoped>
.timeline-spans {
  display: grid;
  gap: var(--drama-space-md);
  margin: 0;
  padding: 0;
  list-style: none;
}

.timeline-spans li {
  display: grid;
  gap: var(--drama-space-xs);
}

.timeline-spans__head {
  display: flex;
  align-items: baseline;
  gap: var(--drama-space-sm);
}

.timeline-spans__head strong {
  font-size: var(--drama-font-size-lg);
}

.timeline-spans__head span {
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
}

.timeline-spans__meter {
  height: 6px;
  border-radius: 3px;
  background: var(--drama-color-surface-alt);
}

.timeline-spans__meter i {
  display: block;
  height: 100%;
  border-radius: 3px;
  background: var(--drama-color-danger);
}

.timeline-spans__what {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--drama-space-xs);
  font-size: var(--drama-font-size-xs);
}

.timeline-spans__detail {
  color: var(--drama-color-text-muted);
}
</style>
